import React from "react";
import "../styles/style.css"; // change later
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa";

const Home = () => {
  return (
    <div>
      <main>
        <div className="project-overview">
          <div className="project-overview-text">
            <h2>
              Documenting Resilience Under Afghanistan's Second Taliban Rule
            </h2>
            <p className="description">
              Understanding contemporary Afghanistan necessitates a
              comprehensive, interdisciplinary approach that considers the
              intersections of human rights, governance, security, gender,
              finance, public health, migration, peacebuilding, and disaster
              response. Impact Afghanistan is a digital scholarship initiative
              that employs text and data mining (TDM), large language models
              (LLMs), and artificial intelligence (AI) technologies to collect,
              verify, and disseminate information through a centralized,
              searchable database. This evolving repository captures the complex
              social, political, and economic dynamics that have emerged since
              the Taliban's return to power as the de facto authority in 2021.
            </p>
            <p className="description">
              Drawing from a wide range of credible sources—including academic
              publications, civil society reports, and journalistic accounts—the
              project offers a nuanced and accessible overview of current
              conditions in Afghanistan. It serves as a resource for scholars,
              policymakers, journalists, humanitarian organizations, and Afghan
              communities, facilitating access to information that may otherwise
              be restricted or suppressed under Taliban governance.
            </p>
            <p className="description">
              The Impact Afghanistan team also conducts original research,
              including surveys, interviews, and focus group discussions, while
              monitoring global responses and publications related to
              Afghanistan. Advanced tools for transcription, data analysis, and
              literature review—powered by AI—support the rigorous documentation
              and analysis of both quantitative and qualitative data.
            </p>
            <p className="description">
              This project contributes to the digital humanities by providing an
              integrated platform for emerging research and fostering sustained
              academic engagement with Afghanistan's evolving post-2021 context.
              Through this work, Impact Afghanistan seeks to amplify
              marginalized voices, support evidence-based decision-making, and
              preserve critical knowledge during a period of profound national
              transition.
            </p>
          </div>
        </div>
        <div className="featured-article">
          <div className="featured-article-text">
            <h2>Featured Article</h2>
            <p className="research-title">
              Distance to Delivery: A Descriptive Brief on the Barriers to
              Maternal Survival in Nooristan, Afghanistan
            </p>
            <p className="author">McKenna Grabowski</p>
            <p className="publication-date">Published in April 2026</p>
            <p className="summary">
              From Introduction: This brief examines the structural and systemic factors driving maternal and neonatal mortality in Nooristan, one of Afghanistan’s most geographically isolated provinces. It explores how limited access to skilled birth attendants, financial and transportation barriers, restrictions on women’s mobility and autonomy, and the declining female healthcare workforce affect access to essential maternal care. The brief also identifies critical gaps in Afghanistan’s government-led, NGO-delivered healthcare model and highlights financing and access, workforce protection, and service delivery readiness as key areas for improving maternal and neonatal survival.

            </p>
            <a
              href="/documents/distance-to-delivery.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read more
            </a>
          </div>
          <div className="featured-article-media">
            <img
              src="https://as1.ftcdn.net/v2/jpg/05/31/43/34/1000_F_531433456_RJvPyap9TwrmdFI55K4sZdpXNJS8sPit.jpg"
              alt="Featured Article"
              width="500"
              height="600"
            />
          </div>
        </div>
        <div className="announcements">
          <div className="announcements-content">
            <div className="announcements-media">
              <div className="iframe-container">
                <iframe
                  src="https://docs.google.com/presentation/d/1iRFKWUwe3Gji4jOqaJbAJJSzVeoGc3JSoNqowct2cnI/embed?start=false&loop=false&delayms=15000"
                  frameBorder="0"
                  width="576"
                  height="358.8"
                  allowFullScreen={true}
                  mozAllowFullScreen={true}
                  webkitAllowFullScreen={true}
                  title="UN Summit of the Future Action Days - Sept 20, 2025"
                ></iframe>
              </div>
            </div>
            <div className="announcements-text">
              <h1>Announcements</h1>
              <div className="announcements-copy">
                <p>
                  1. We have officially launched! Please submit your research
                  via the <a href="/form">submission form</a>.
                </p>
                <p>
                  2. In our <a href="/engagement">Engagement tab</a>, see what
                  we've been up to as of late.
                </p>
                <p>
                  3. See our presentation from September 20, 2025, at the
                  United Nations Summit of the Future Action Days! More
                  information can be found{" "}
                  <a href="https://powerinhervoicereimaginingagen.splashthat.com/">
                    here
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="resources">
          <div className="resources-text">
            <h2>Other Resources</h2>
            <ul>
              <li>
                <a href="https://dsi.brown.edu/">
                  Brown Data Science Institute
                </a>
              </li>
              <li>
                <a href="https://library.brown.edu/create/cds/projects/">
                  Brown Center for Digital Scholarship
                </a>
              </li>
              <li>
                <a href="https://watson.brown.edu/southasia/">
                  Watson Institute's Center for Contemporary South Asia
                </a>
              </li>
              <li>
                <a href="https://www.un.org/en/summit-of-the-future/">
                  UN Summit of the Future
                </a>
              </li>
            </ul>
          </div>
          <div className="resources-media">
            <img
              src="/images/other-resources.png"
              alt="Person working at a laptop and taking notes"
              width="500"
              height="600"
            />
          </div>
        </div>
      </main>
      <footer className="footer">
        <div className="copy">
          &copy; 2024&ndash;{new Date().getFullYear()} Impact Afghanistan - All Rights Reserved.
        </div>
        <div className="bottom-links">
          <div className="links">
            <a href="mailto:impactcompact.afghanistan@gmail.com">
              <FaEnvelope /> impactcompact.afghanistan@gmail.com
            </a>
            <a
              className="icon-link"
              href="https://www.linkedin.com/in/impactafghanistan/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              className="icon-link"
              href="https://www.instagram.com/impactafghanistan1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
